export function getS3ObjectUrl(bucket: string, region: string, fileLocation: string): string {
  return `https://${bucket}.s3.${region}.amazonaws.com/${fileLocation}`
}
